import CheckCircle from '@/public/icons/check-circle.svg'
export default function SetStrongPassword() {
  const resources = [
    {
      title: 'Không sử dụng các mật khẩu quen thuộc',
      description:
        'Nhiều người dùng có thói quen nguy hiểm đó là tạo ra các mật khẩu quen thuộc, liên quan đến thông tin cá nhân như tên, số điện thoại để dễ nhớ. Tuy nhiên, điều này tạo nên cơ hội cho các hacker dễ dàng đoán ra và xâm nhập vào thông tin cá nhân của bạn. Các mật khẩu quen thuộc phải kể đến như 123456, password, password1, iloveyou, nguyenlananh123 (họ tên kèm đuôi 123)… Các bạn nên tránh đặt các mật khẩu này nếu không muốn là người tiếp theo bị lộ các thông tin riêng tư.',
    },
    {
      title: 'Tạo mật khẩu dài trên 10 ký tự',
      description:
        'Mật khẩu càng dài thì càng an toàn. Một mật khẩu mạnh phải có trên 10 ký tự. Với mật khẩu càng dài, hacker sẽ càng mất thời gian và công sức nếu muốn bẻ khóa. Bạn có thể tạo ra các mật khẩu dài bằng cách trích dẫn câu nói, lời bài hát yêu thích, tên bộ phim…Điều này vừa tạo ra một mật khẩu mạnh vừa phòng tránh trường hợp bạn quên mất mật khẩu mình đã đặt. Ví dụ, với một câu nói nổi tiếng trong phim “Braveheart”: “They may take our lives, but they’ll never take our freedom!”. Bạn có thể đặt mật khẩu bằng cách viết các chữ cái đầu và thêm vào một vài con số: tmtolbtwnvtof3. Đây là một mật khẩu cực mạnh và để đoán được gần như là điều không thể.',
    },
    {
      title: 'Kết hợp các kí tự chữ cái, số, ký tự đặc biệt',
      description:
        'Một mật khẩu dài là chưa đủ để đảm bảo an toàn bảo mật. Mỗi mật khẩu cần phải kết hợp chữ cái, số, chữ in hoa và kí tự đặc biệt để tạo thành một chuỗi ký tự riêng biệt, không giống với các thông tin cá nhân của người dùng. Việc sử dụng các kí tự đặc biệt rất hiệu quả để làm phức tạp mật khẩu của bạn. Các kí tự thường dùng như: @, /, ?, !, )(, ^…. Hoặc cách đơn giản hơn bạn có thể xen lẫn chữ cái in hoa và in thường trong mật khẩu. Ví dụ thay vì dùng mật khẩu “homnaydihoc”, bạn nên dùng “homNAY/diHoc@.',
    },
    {
      title: 'Mỗi tài khoản sử dụng một mật khẩu riêng biệt',
      description:
        'Nếu bạn tạo được một mật khẩu dài, phức tạp tuy nhiên lại dùng chung cho nhiều tài khoản sẽ đem lại rủi ro rất lớn. Khi hacker có thể xâm nhập vào một tài khoản internet bạn đang dùng, nguy cơ lớn các tài khoản khác sẽ bị rò rỉ thông tin. Chính vì vậy, việc tạo các mật khẩu mạnh cho từng tài khoản là điều vô cùng quan trọng.',
    },
    {
      title: 'Sử dụng trình tạo mật khẩu an toàn',
      description:
        'Hiện nay có nhiều phần mềm hỗ trợ người dùng tạo ra các mật khẩu mạnh. Các trang web này là công cụ giúp bạn tạo ra các mật khẩu mạnh, duy nhất và hoàn toàn ngẫu nhiên. Locker là trình quản lý mật khẩu an toàn, uy tín mà bạn có thể tham khảo. Ngoài giúp bạn tạo ra những mật khẩu mạnh, duy nhất cho từng tài khoản, Locker còn giúp người dùng lưu giữ các mật khẩu, tự động điền mật khẩu giúp người dùng đăng nhập vào các trang web một cách nhanh chóng, dễ dàng.',
    },
  ]
  return (
    <section className="py-24 password-generator-set-strong-password">
      <div className="max-w-[1008px] lg:px-0 px-5 mx-auto">
        <h2 className="text-display-lg font-semibold text-heading mb-5 text-center">
          Cách đặt mật khẩu mạnh cho tài khoản
        </h2>
        <div className="my-12 flex items-center gap-2">
          <span className="block h-[1px] bg-primary-HOVER w-full"></span>
          <span className="text-primary whitespace-nowrap flex-1 font-semibold">
            <CheckCircle className="w-6 h-6" />
          </span>
          <span className="block h-[1px] bg-primary-HOVER w-full"></span>
        </div>
        <ul className="list-none space-y-8">
          {resources.map((item, index) => (
            <li key={index} className="md:p-8 p-4 rounded-3xl md:flex gap-6 space-y-5 bg-gray-50">
              <span className="flex items-center justify-center rounded-full size-[60px] bg-primary text-white text-display-md flex-shrink-0">
                {index + 1}
              </span>
              <div className="space-y-4">
                <h3 className="text-heading text-display-xs font-semibold">{item.title}</h3>
                <p className="text-md text-gray-700">{item.description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
